<div [ngClass]="homePage.greyOut ? 'skinGrey' : ''">
  <div class="wrapper">
    <app-header
      *ngIf="!isSandboxLogViewPage"
      [disableHeader]="isRegisterPage"
    ></app-header>
    <app-top-menu
      *ngIf="!isRegisterPage && !isSandboxLogViewPage"
    ></app-top-menu>
    <router-outlet></router-outlet>

    <div class="push"></div>
  </div>
  <!-- sticky footer -->
  <app-footer *ngIf="!isSandboxLogViewPage" class="footer"></app-footer>

  <div *ngIf="isLoading()">
    <app-page-loader></app-page-loader>
  </div>
</div>
